import { SeoBlock } from 'models/SeoBlock';
import Markdown from 'components/Shared/Markdown';
import styles from './seo.scss';
import { Section } from 'components/Section';
import { Appearances } from 'models/SectionBlock';

export const SeoSection = ({ header, content }: SeoBlock) => (
  <Section appearance={Appearances.Secondary} contentClassName={styles.infoBlock}>
    <h2>{header}</h2>
    <Markdown className={styles.description} content={content} tag="div" />
  </Section>
);
